<template>
    <auth-card-template class="h-p-auth-phone-verification" :large="showSurvey">
        <card-auth v-if="showSurvey">
            <h4 class="font-title font-weight-bold text-success text-left mb-6">
                Olá, {{ userName }}!
            </h4>

            <p>
                Na Hostoo, ajudamos você a colocar seu site no ar. A hospedagem é como a <strong>casa do seu site</strong>,
                tornando-o acessível para todos na internet. Para saber como podemos ajudar, conte para nós:
            </p>

            <p class="card-title font-title font-weight-bold text-primary">
                Qual o seu principal objetivo ao buscar uma hospedagem de sites?
            </p>

            <form @submit.prevent="saveSurvey">
                <form-group :error="formErrors.mql">
                    <select id="mql" class="custom-select" v-model="formData.mql">
                        <option value="" disabled>Clique e selecione uma das opções disponíveis&hellip;</option>
                        <option value="1">Não sei o que é hospedagem de sites ou procurava outro serviço.</option>
                        <option value="2">Quero criar um site novo, mas sou iniciante no assunto.</option>
                        <option value="3">Crio ou gerencio sites e estou testando novas hospedagens.</option>
                        <option value="4">Já tenho sites e estou decidido a migrar para uma hospedagem melhor.</option>
                    </select>
                </form-group>

                <div class="form-buttons text-center">
                    <button-form ref="btnSaveSurvey" type="submit" theme="success" class="btn-lg">
                        Próximo
                    </button-form>
                </div>
            </form>
        </card-auth>

        <card-auth v-show="userEmail && !showSurvey">
            <h4 class="font-title font-weight-bold text-success text-center mb-6">
                Confirme seu telefone
            </h4>

            <div v-show="!isPhoneChecked">
                <div class="mb-6">
                    <p>
                        Agora que você já faz parte da Hostoo, pedimos que você confirme o seu
                        <strong>telefone celular</strong> para tornar sua conta ainda mais segura.
                    </p>
                    <p class="mb-0">
                        Você receberá um SMS com um <strong>código de verificação</strong> no telefone informado
                        abaixo.
                    </p>
                </div>

                <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

                <form @submit.prevent="checkPhone">
                    <form-group label="Celular" label-for="userPhone" :error="formErrors.phone">
                        <the-mask
                            type="tel"
                            id="userPhone"
                            class="form-control"
                            autocomplete="tel-national"
                            placeholder="(00) 00000-0000"
                            autofocus
                            :mask="['(##) ####-####', '(##) #####-####']"
                            v-model="formData.phone" />
                    </form-group>

                    <input type="hidden" id="userEmail" name="userEmail" :value="userEmail">

                    <div v-if="isPhoneUnavailable" class="alert alert-warning">
                        O telefone informado <strong>não está qualificado</strong> a receber o bônus de cadastro,
                        pois já foi utilizado anteriormente. Para utilizá-lo assim mesmo, clique no botão abaixo.
                    </div>

                    <div class="form-buttons text-center">
                        <button-form ref="btnCheckPhone" type="submit" theme="success" class="btn-lg px-8">
                            {{ isPhoneUnavailable ? "Continuar" : "Verificar" }}
                        </button-form>
                    </div>
                </form>

                <div v-show="errorMessage" class="text-center mt-6">
                    <router-link to="/auth/login" class="text-lg font-weight-semibold">Voltar para o login</router-link>
                </div>
            </div>

            <div v-show="isPhoneChecked">
                <div class="text-center">
                    <p>
                        Muito bom! Agora enviamos um SMS para o celular informado com um
                        <strong>código de 6 dígitos</strong>. Ao receber o código, informe-o no campo
                        abaixo e aperte o botão para confirmar.
                    </p>
                    <p class="text-muted">
                        Se não receber a mensagem em até <strong>5 minutos</strong>, por favor, tente novamente
                        ou entre em contato com nosso suporte.
                    </p>
                </div>

                <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

                <form @submit.prevent="verifyPhone">
                    <form-group class="bg-transparent mb-0" :error="formErrors.code">
                        <div class="group-code mt-6 mb-2">
                            <div class="row no-gutters px-6">
                                <template v-for="n in 6">
                                    <div class="col-2" :key="n">
                                        <div class="form-group mx-2">
                                            <input
                                                type="tel"
                                    A            :id="'input-code-'+n"
                                                class="form-control text-center"
                                                maxlength="1"
                                                v-bind:value="getCodeAsArray(n-1)"
                                                @keydown="onKeyDown(n, $event)">
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </form-group>

                    <div class="text-center mb-4">
                        <p v-show="verificationTime" class="text-muted">
                            Aguarde {{ getFormattedTime }} para reenviar o SMS...
                        </p>
                        <div v-if="!verificationTime" class="mb-3">
                            <button type="button" ref="btnResendCode" class="btn btn-link p-0 text-lg font-weight-semibold" @click="resendCode">Reenviar código</button>
                        </div>
                    </div>

                    <div class="form-buttons text-center">
                        <button-form type="submit" ref="btnVerifyPhone" theme="success" class="btn-lg px-8">Confirmar</button-form>
                    </div>
                </form>
            </div>
        </card-auth>
    </auth-card-template>
</template>

<script>
import {mapActions, mapState} from 'vuex'
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import FormGroup        from '@/components/molecules/FormGroup'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'
    import ErrorService     from '@/services/error.service'

    export default {
        components: {
            ButtonForm,
            FormGroup,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                verificationToken: '',
                verificationCode: [],
                verificationTime: 300,
                verificationInterval: null,
                userEmail: null,
                userName: null,

                formData: {},
                formErrors: {},
                errorMessage: '',
                isPhoneUnavailable: false,
                isPhoneChecked: false,
                isPhoneVerified: false,

                isAdsTracked: false,
                isGa4Tracked: false,

                showSurvey: false,

            }
        },
        computed: {
            ...mapState({
                errorMessageGlobal: state => state.alert.message,
            }),

            getFormattedTime: function ()
            {
                return ('00' + Math.floor(this.verificationTime / 60).toString()).slice(-2)
                     + ':'
                     + ('00' + (this.verificationTime % 60).toString()).slice(-2);
            }
        },
        beforeRouteEnter(to, from, next)
        {
            if (to.query.token) {
                next(vm => { vm.verificationToken = to.query.token; });
            }
            else {
                next('/auth/login');
            }
        },
        mounted()
        {
            // Tag de conversão do Facebook
            if (typeof window.fbq !== "undefined") {
                fbq('trackCustom', 'PG-Registro-Celular');
            }

            this.verificationCode = Array(6).fill("");

            if (!this.verificationToken) {
                this.verificationToken = this.$route.query.token;
            }

            this.validateToken();
        },
        methods: {
            ...mapActions({
                showErrorAlert: 'alert/error'
            }),

            /**
             * Verificar o token.
             */
            validateToken()
            {
                this.$api.get('/user/validate-token?verificationToken=' + this.verificationToken)
                    .then(response => {
                        this.userEmail  = response.data.data.email;
                        this.userName   = response.data.data.name;
                        this.showSurvey = response.data.data.showSurvey;

                        if (this.showSurvey) {
                            this.formData.mql = "";
                        }
                    })
                    .catch(error => {
                        ErrorService.handleAuthFormError(error, this, (message) => {
                            const status = error.response ? error.response.status : 0;
                            alert(message);

                            if (status === 401) {
                                window.location.href = "/auth/login";
                            }
                        });
                    });
            },

            /**
             * Salvar respostas da pesquisa.
             */
            saveSurvey()
            {
                this.$refs.btnSaveSurvey.enableLoading();

                this.$api.post("/user/survey/mql", {
                    verificationToken: this.verificationToken,
                    mql: this.formData.mql
                })
                    .then(() => {
                        this.showSurvey = false;
                    })
                    .catch(error => {
                        ErrorService.handleAuthFormError(error, this, (message) => {
                            alert(message);
                        });
                    })
            },

            /**
             * Verificar se o telefone informado é válido.
             */
            checkPhone()
            {
                this.formErrors = {};
                this.errorMessage = "";
                this.isPhoneChecked = false;

                this.$refs.btnCheckPhone.loadingFocus();

                const postData = Object.assign({ verificationToken: this.verificationToken }, this.formData);

                if (this.isPhoneUnavailable) {
                    postData["acceptUnavailable"] = true;
                }
                else {
                    this.isPhoneUnavailable = false;
                }

                this.$api.post('/user/check-phone', postData)
                    .then(response => {
                        if (response.data.data && response.data.data.isUnavailable) {
                            this.isPhoneUnavailable = true;
                            this.$refs.btnCheckPhone.disableLoading();
                        }
                        else {
                            this.verificationTime = 300;
                            this.verificationInterval = setInterval(this._updateVerificationTime, 1000)
                            this.isPhoneChecked = true;
                        }
                    })
                    .catch(error => {
                        ErrorService.handleAuthFormError(error, this, (message) => this.errorMessage = message);
                        this.$refs.btnCheckPhone.disableLoading();
                    });
            },

            /**
             * Reenviar código de confirmação.
             */
            resendCode()
            {
                if (this.verificationInterval) {
                    clearInterval(this.verificationInterval);
                }

                this.verificationTime = 300;
                this.$refs.btnCheckPhone.disableLoading();
                this.isPhoneChecked = false;
            },

            /**
             * Verificar telefone usando o código recebido.
             */
            verifyPhone()
            {
                this.formErrors = {};
                this.errorMessage = '';
                this.isPhoneVerified = false;

                this.$refs.btnVerifyPhone.loadingFocus();

                const postData = {
                    verificationToken: this.verificationToken,
                    code: this.verificationCode.join(''),
                };

                this.$api.post('/user/verify-phone', postData)
                    .then(response => {
                        // Salvar token de acesso
                        let options = {
                            expires: new Date(response.data.data.expiration * 1000),
                            secure: true,
                            samesite: 'strict',
                        };

                        if (process.env.NODE_ENV === 'production') {
                            options.domain = '.hostoo.io';
                        }

                        this.$cookie.set('access_token', response.data.data.token, options);

                        // Tag de conversão do Facebook
                        if (typeof window.fbq !== "undefined") {
                            fbq('trackCustom', 'PG-Confirmou-Celular');
                        }

                        if (typeof window.gtag !== "undefined")
                        {
                            // Tag do GA4
                            if (typeof window.GA4_MEASUREMENT_ID !== 'undefined')
                            {
                                gtag('event', 'form_completo', {
                                    'send_to': window.GA4_MEASUREMENT_ID,
                                    'event_callback': () => {
                                        this.isGa4Tracked = true;
                                        setTimeout(() => { this.redirectAfterTrack(); }, 100);
                                    }
                                });
                            }
                            else {
                                this.isGa4Tracked = true;
                            }

                            // Tag de conversão do Google Ads
                            gtag('event', 'conversion', {
                                'send_to': 'AW-798302531/ZRSBCMrWkcQBEMPC1PwC',
                                'event_callback': () => {
                                    this.isAdsTracked = true;
                                    setTimeout(() => { this.redirectAfterTrack(); }, 200);
                                }
                            });
                        }
                        else {
                            this.isAdsTracked = true;
                            this.isGa4Tracked = true;
                            this.redirectAfterTrack();
                        }
                    })
                    .catch(error => {
                        const status  = error.response ? error.response.status : 0;

                        if (status === 422) {
                            this.errorMessage = error.response.data.data.code;
                        }
                        else {
                            ErrorService.handleAuthFormError(error, this, (message) => this.errorMessage = message);
                        }

                        this.$refs.btnVerifyPhone.disableLoading();
                    });
            },

            redirectAfterTrack()
            {
                if (this.isAdsTracked && this.isGa4Tracked) {
                    window.location.href = '/welcome';
                }
                else {
                    // after 5 seconds, always redirect to avoid stopping
                    setTimeout(() => { window.location.href = '/welcome'; }, 5000);
                }
            },

            getCodeAsArray(index)
            {
                if (typeof index === "undefined") {
                    return this.verificationCode;
                }
                else {
                    return this.verificationCode[index];
                }
            },

            onKeyDown(position, evt)
            {
                const key = evt.which || evt.keyCode;

                // BACKSPACE
                if (key === 8)
                {
                    evt.preventDefault();

                    this.$set(this.verificationCode, (position-1), '');

                    if (position > 1) {
                        document.getElementById("input-code-"+(position-1)).focus();
                    }

                    return false;
                }

                // DELETE
                else if (key === 46)
                {
                    evt.preventDefault();
                    this.$set(this.verificationCode, (position-1), '');
                    return false;
                }

                else {
                    let value = String.fromCharCode(key);

                    if (evt.key && evt.key !== 'Unidentified') {
                        value = evt.key;
                    }

                    if (value && /^\d+$/.test(value))
                    {
                        evt.preventDefault();

                        this.$set(this.verificationCode, (position-1), value);

                        if (position < 6) {
                            document.getElementById("input-code-"+(position+1)).focus();
                        }

                        return false;
                    }
                }
            },

            /**
             * Atualizar temporizador para reenvio de SMS.
             */
            _updateVerificationTime()
            {
                if (this.verificationTime > 0) {
                    this.verificationTime--;
                }
                else {
                    clearInterval(this.verificationInterval);
                }
            },
        },
        watch: {
            'formData.phone': function(val, old)
            {
                if (val != old) {
                    this.isPhoneUnavailable = false;
                    this.isPhoneChecked = false;
                }
            }
        }
    }
</script>

<style lang="stylus">
    .h-p-auth-phone-verification
        .h-o-card-auth .group-code .form-control
            padding .625rem 0
            font-size 2rem
</style>